// generated by genversion
module.exports = '1.6.0'
